
import { defineComponent } from "vue";
import { ImagePreview } from "vant";

export default defineComponent({
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    evalDetail: {
      type: Object,
      default: null
    },
    placement: {
      type: String,
      default: 'bottom'
    }
  },

  methods: {
    previewImage(index: number, url?: string) {
      ImagePreview({
        images: url ? [url] : this.evalDetail.imgsUrl.split(';'),
        startPosition: url ? 0 : index,
        closeable: true
      });
    },
    handleUname(uname: string) {
      if (uname && uname.length > 5) return `${uname.slice(0, 4)}...`;
      else return uname;
    }
  }
})
